import React from 'react'
function Button({onPress,classgiven,name,style,disabled}) {
  return (
    <button disabled={disabled} style={style} className={classgiven ? classgiven :"link btn-basic new btn-basic2"} onClick={onPress}>{name}</button>
  )
}

export {Button}